import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { OrdersService } from 'src/app/services/orders.service';

@Component({
  selector: 'app-past-orders',
  templateUrl: './past-orders.component.html',
  styleUrls: ['./past-orders.component.css']
})
export class PastOrdersComponent implements OnInit {

  orders = [];
  ordersEmpty = false;

  constructor(private ordersService: OrdersService, private snackBar: MatSnackBar) { }

  ngOnInit() {
    const data = new FormData();

    this.ordersService.getAllOrders(data).subscribe(result => {
      this.orders = result.data;
    }, error => {
      this.ordersEmpty = true;
    })
  }
}
